/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';
import {
  getUseMethodDecoder,
  getUseMethodEncoder,
  type UseMethod,
  type UseMethodArgs,
} from '.';

export type Uses = { useMethod: UseMethod; remaining: bigint; total: bigint };

export type UsesArgs = {
  useMethod: UseMethodArgs;
  remaining: number | bigint;
  total: number | bigint;
};

export function getUsesEncoder(): FixedSizeEncoder<UsesArgs> {
  return getStructEncoder([
    ['useMethod', getUseMethodEncoder()],
    ['remaining', getU64Encoder()],
    ['total', getU64Encoder()],
  ]);
}

export function getUsesDecoder(): FixedSizeDecoder<Uses> {
  return getStructDecoder([
    ['useMethod', getUseMethodDecoder()],
    ['remaining', getU64Decoder()],
    ['total', getU64Decoder()],
  ]);
}

export function getUsesCodec(): FixedSizeCodec<UsesArgs, Uses> {
  return combineCodec(getUsesEncoder(), getUsesDecoder());
}
